export default __webpack_public_path__ + "static/kent@2x-ac87c1a1acbcdb26d639b02bdd1964c6.png";